import { useState } from 'react';

function UsersTab({ users, deleteUser, makeAdmin }) {
  const [searchUsers, setSearchUsers] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const USERS_PER_PAGE = 20;

  const filteredUsers = users.filter(u => 
    !searchUsers || 
    u.username.toLowerCase().includes(searchUsers.toLowerCase()) || 
    u.email.toLowerCase().includes(searchUsers.toLowerCase())
  );

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * USERS_PER_PAGE, 
    currentPage * USERS_PER_PAGE
  );

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Quản lý Users</h2>
        <input 
          type="text" 
          value={searchUsers} 
          onChange={(e) => { setSearchUsers(e.target.value); setCurrentPage(1); }} 
          placeholder="Tìm user..." 
          className="px-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500" 
        />
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">User</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Email</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Role</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Followers</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Ngày tạo</th>
              <th className="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {paginatedUsers.map(user => (
              <tr key={user._id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="flex items-center gap-3">
                    <img 
                      src={user.avatar || `https://api.dicebear.com/7.x/notionists/svg?seed=${user.username}`} 
                      className="w-10 h-10 rounded-full" 
                      alt="" 
                    />
                    <div>
                      <p className="font-semibold">{user.displayName || user.username}</p>
                      <p className="text-sm text-gray-500">@{user.username}</p>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-3 text-sm">{user.email}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${
                    user.role === 'admin' ? 'bg-purple-100 text-purple-800' : 'bg-gray-100 text-gray-800'
                  }`}>
                    {user.role === 'admin' ? 'Admin' : 'User'}
                  </span>
                </td>
                <td className="px-4 py-3 text-sm">{user.followers?.length || 0}</td>
                <td className="px-4 py-3 text-sm">{new Date(user.createdAt).toLocaleDateString('vi-VN')}</td>
                <td className="px-4 py-3 text-right">
                  <div className="flex items-center justify-end gap-2">
                    {user.role !== 'admin' && (
                      <button 
                        onClick={() => makeAdmin(user._id)} 
                        className="px-3 py-1 text-xs font-semibold text-purple-600 hover:bg-purple-50 rounded-lg transition-colors"
                      >
                        Make Admin
                      </button>
                    )}
                    <button 
                      onClick={() => deleteUser(user._id, user.username)} 
                      className="px-3 py-1 text-xs font-semibold text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {Math.ceil(filteredUsers.length / USERS_PER_PAGE) > 1 && (
        <div className="flex items-center justify-between mt-6">
          <div className="text-sm text-gray-600">
            Trang {currentPage} / {Math.ceil(filteredUsers.length / USERS_PER_PAGE)}
          </div>
          <div className="flex gap-2">
            <button 
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))} 
              disabled={currentPage === 1}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Trước
            </button>
            <button 
              onClick={() => setCurrentPage(p => Math.min(Math.ceil(filteredUsers.length / USERS_PER_PAGE), p + 1))} 
              disabled={currentPage === Math.ceil(filteredUsers.length / USERS_PER_PAGE)}
              className="px-4 py-2 border rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Sau
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default UsersTab;
